function remToPx(remValue: string): number {
  // const rootFontSize = parseFloat(
  //   getComputedStyle(document.documentElement).fontSize,
  // );
  const rootFontSize = 16;

  const rem = parseFloat(remValue);
  return rem * rootFontSize;
}

const TAILWIND_BREAKPOINTS = {
  sm: '--breakpoint-sm',
  md: '--breakpoint-md',
  lg: '--breakpoint-lg',
  xl: '--breakpoint-xl',
  '2xl': '--breakpoint-2xl',
} as const;

type TailwindBreakpoint = keyof typeof TAILWIND_BREAKPOINTS;

function getTailwindBreakpointPx(
  breakpoint: TailwindBreakpoint,
): number | undefined {
  const cssVar = TAILWIND_BREAKPOINTS[breakpoint];
  const value = getComputedStyle(
    document.documentElement,
  ).getPropertyValue(cssVar);

  if (!value) return undefined;

  return remToPx(value);
}

export function windowComparedToTailwindBreakpointIs(
  direction: 'smaller' | 'bigger',
  breakpoint: TailwindBreakpoint,
): boolean {
  const breakpointPx = getTailwindBreakpointPx(breakpoint);
  if (breakpointPx === undefined) return false;

  const windowWidth = window.innerWidth;

  if (direction === 'smaller') {
    return windowWidth < breakpointPx;
  } else {
    return windowWidth >= breakpointPx;
  }
}

export function valueComparedToTailwindBreakpointIs(
  value: number,
  direction: 'smaller' | 'bigger',
  breakpoint: TailwindBreakpoint,
): boolean {
  const breakpointPx = getTailwindBreakpointPx(breakpoint);
  if (breakpointPx === undefined) return false;

  if (direction === 'smaller') {
    return value < breakpointPx;
  } else {
    return value >= breakpointPx;
  }
}
